import {createDisplayImageField} from './createDisplayImageField';

export const BACKGROUND_MENU_FIELD = createDisplayImageField(
  'backgroundMenu',
  'Background Menu'
);

export const BACKGROUND_IMAGE_FIELD = createDisplayImageField(
  'backgroundImage',
  'Background Image'
);

export const BACKGROUND_IMAGES_SECTION_DEFAULTS = {
  title: 'Background Images',
  subtitle: 'Background images displayed within the game.'
};

export const createImageUploadSectionConfig = ({
  testId,
  downloadButtonIcon = 'leading',
  downloadButtonId,
  guidelineButtonId,
  title,
  subtitle
}) => ({
  ...(title && subtitle
    ? {title, subtitle}
    : BACKGROUND_IMAGES_SECTION_DEFAULTS),
  testId,
  downloadButtonIcon,
  ...(downloadButtonId && {downloadButtonId}),
  ...(guidelineButtonId && {guidelineButtonId})
});
